import { Button, Col, Flex, Form, Input, InputNumber, notification, Row, Spin } from "antd";
import { ReactElement, useEffect } from "react";
import { useBuscar, useSalvar } from "../../../../../Services/Financeiro/Faturamento/ServicoServices";
import Servico from "../../../../../Models/Financeiro/Faturamento/Servico";
import { useParams } from "react-router-dom";
import { PropriedadesDeNotificacao } from "../../../../../Utils/Notificacoes";
import ValorServicoFormBasic from "../Imposto/Configuracao/Valor/ValorServico/ValorServicoFormBasic";
import { EnumGrupoTributario } from "../../../../../Models/Financeiro/Faturamento/Imposto/GrupoTributario";
import RegimeTributario, { EnumRegimeTributario } from "../../../../../Models/Financeiro/Faturamento/Imposto/RegimeTributario";
import RegimeTributarioSelectMult from "../Imposto/RegimeTributario/RegimeTributarioSelectMult";
import ValorServico from "../../../../../Models/Financeiro/Faturamento/Imposto/Configuracao/Valor/ValorServico";
import { useListar } from "../../../../../Services/Financeiro/Faturamento/Imposto/RegimeTributarioServices";
import Utilitario from "../../../../../Utils/Utilitario";
import ComponentePermissao from "../../../../Base/Permissao/ComponentePermissao";
import { PermissoesKey } from "../../../../../Constants/Permissoes";
interface IServicoFormCadastroProps {
    buttoCencelar?: ReactElement,
    onCancelar?: (evento: React.MouseEvent<HTMLElement, MouseEvent>) => void,
    onSalvarSucesso?: (codServico:number|void) => void
}
type FormType = {
    servico:Servico,
    isAlteracao:boolean
};
export default function ServicoFormCadastro({
    buttoCencelar,
    onCancelar,
    onSalvarSucesso
}: IServicoFormCadastroProps) {
    const { codigo } = useParams();
    const isAlteracao = codigo !== undefined && codigo !== null && Number.parseInt(codigo) > 0;
    const [formulario] = Form.useForm<FormType>();
    const regimesTributarios = Form.useWatch<RegimeTributario[]>(["servico", "regimesTributarios"], formulario);

    const {
        data : dataRegimeTributario,
        isPending : isPendingRegimeTributario,
        isSuccess : isSuccessRegimeTributario,
        isError : isErrorRegimeTributario
    } = useListar({
        ativo : true,
        enabled : isAlteracao
    });

    const {
        isSuccess,
        isError,
        isPending : isPedingBuscarServico,
        data : servicoSalvo
    } = useBuscar({
        codigo : Number.parseInt(codigo as string),
        enabled : isAlteracao && isSuccessRegimeTributario
    });

    const {
        mutate,
        isPending
    } = useSalvar({
        onSuccess: onSalvarSucesso
    });

    useEffect(() => {
        if (isErrorRegimeTributario || isError || (isSuccess && servicoSalvo === null)) {
            onCancelar?.({} as any);
            notification.info({
                ...PropriedadesDeNotificacao["Aviso"],
                message : "Não foi possível encontrar o serviço que deseja alterar."
            });
        }
    }, [isErrorRegimeTributario, isError, isSuccess, servicoSalvo]);

    useEffect(() => {
        if (isSuccess && servicoSalvo !== null) {
            servicoSalvo.regimesTributarios = Utilitario.groupBy(
                    servicoSalvo.valoresImpostos.map(m => m.valor?.codRegimeTributario),
                    (codRegimeTributario) => codRegimeTributario
                ).filter(f => f.chave != null)
                .map(m => dataRegimeTributario?.find(f => f.codigo == m.chave))
                .filter(f => f != null)
            ;
    
            formulario.setFieldsValue({
                isAlteracao : isAlteracao,
                servico : {
                    ...servicoSalvo
                }
            });
        }
    }, [isSuccess, servicoSalvo, dataRegimeTributario]);

    return <Spin spinning={isAlteracao && (isPedingBuscarServico || isPendingRegimeTributario)} delay={500}>
        <Form<FormType>
            layout="vertical"
            autoComplete="off"
            onFinish={(data) => {
                if (isAlteracao)
                    data.servico.codigo = Number.parseInt(codigo as string);
                mutate(data);
            }}
            form={formulario}
        >
            <Row gutter={8} wrap>
                <Col xs={24}>
                    <Form.Item<FormType> name={"isAlteracao"} initialValue={false} hidden={true}>
                        <Input hidden={true} />
                    </Form.Item>
                </Col>
                <Col xs={18}>
                    <Form.Item<FormType> name={["servico", "nome"]} label={"Nome"} rules={[
                        {
                            required : true,
                            min : 3,
                            max : 256
                        }
                    ]}>
                        <Input placeholder="Nome" />
                    </Form.Item>
                </Col>
                <Col xs={6}>
                    <Form.Item<FormType> name={["servico", "codigoServico"]} label={"Código do serviço"} rules={[
                        {
                            required : true
                        }
                    ]}>
                        <InputNumber style={{ width : "100%" }}  placeholder="Código do serviço" />
                    </Form.Item>
                </Col>
                <Col xs={24}>
                    <Form.Item<FormType> name={["servico", "descricao"]} label={"Descrição"} rules={[
                        {
                            required : false,
                            max : 500
                        }
                    ]}>
                        <Input.TextArea placeholder="Descrição" />
                    </Form.Item>
                </Col>
                <Col xs={24}>
                    <Form.Item<FormType> name={["servico", "regimesTributarios"]} rules={[
                        {
                            required : true,
                            message : "Selecione ao menos 1 regime tributário"
                        }
                    ]}>
                        <RegimeTributarioSelectMult
                            onDeselect={(value) => {
                                formulario.setFieldValue(
                                    ["servico","valoresImpostos"],
                                    (formulario.getFieldValue(["servico","valoresImpostos"]) as ValorServico[] ?? [])
                                    .filter(f => f.valor?.codRegimeTributario != value)
                                );
                            }}
                            onClear={() => {
                                formulario.setFieldValue(["servico","valoresImpostos"], []);
                            }}
                        /> 
                    </Form.Item>
                </Col>
                <Col xs={24}>
                {
                    regimesTributarios?.map(({codigo, nome}) => <Form.Item<FormType> key={codigo} name={["servico","valoresImpostos"]}>
                        <ValorServicoFormBasic
                            codGrupoTributario={EnumGrupoTributario.Servico}
                            codRegimeTributario={codigo}
                            nomeRegimeTributario={nome}
                        />
                    </Form.Item>)
                }
                </Col>
            </Row>
            <Flex gap="small" wrap="wrap" justify="center">
                {!!buttoCencelar && buttoCencelar}
                {
                    !!!buttoCencelar && !!onCancelar && <Button type='primary' danger htmlType='reset' onClick={onCancelar}>
                        Cancelar
                    </Button>
                }
                <ComponentePermissao tipo="any" permissoes={["FinanceiroFaturamentoServicoAlterar", "FinanceiroFaturamentoServicoInserir"]}>
                    <Button type='primary' htmlType='submit' loading={isPending}>
                        Salvar
                    </Button>
                </ComponentePermissao>
            </Flex>
        </Form>
    </Spin>;
}

